"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_on_images_loaded_1 = require("react-on-images-loaded");
var OnImagesLoaded = (function (_super) {
    __extends(OnImagesLoaded, _super);
    function OnImagesLoaded(props) {
        var _this = _super.call(this, props) || this;
        _this._onLoaded = _this._onLoaded.bind(_this);
        _this._onTimeout = _this._onTimeout.bind(_this);
        return _this;
    }
    OnImagesLoaded.prototype._onLoaded = function () {
        this.props.onLoaded && this.props.onLoaded.bind(this);
    };
    OnImagesLoaded.prototype._onTimeout = function () {
        this.props.onTimeout && this.props.onTimeout.bind(this);
    };
    OnImagesLoaded.prototype.render = function () {
        var _a = this.props, onLoaded = _a.onLoaded, onTimeout = _a.onTimeout, timeout = _a.timeout, tag = _a.tag, children = _a.children;
        return (React.createElement("div", { "data-tag": tag },
            React.createElement(react_on_images_loaded_1.default, { onLoaded: onLoaded, onTimeout: onTimeout, timeout: timeout }, children)));
    };
    return OnImagesLoaded;
}(React.Component));
OnImagesLoaded.defaultProps = {
    tag: null,
    timeout: 7000,
    onLoaded: function () { },
    onTimeout: function () { }
};
exports.OnImagesLoaded = OnImagesLoaded;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["OnImagesLoaded"] = [];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/OnImagesLoaded/OnImagesLoaded.js
// module id = 474
// module chunks = 0